import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IPageDataV4 } from '@df/catalog/cms/cms-model.interface';
import { TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ICmsPage } from '@icms/core/resource/page/icms-page';
import { NBlogPostPageType } from '../../page/post-view/cms-blog-post.namespace';
import { CmsBlogComponentMoreStoriesItemComponent } from './item/cms-blog-component-more-stories-item.component';
export interface IPageComponentBlogMoreStoriesData extends NICmsContentComponent.IData {
    title?: string;
    title_font_style?: string;
    items?: IPageComponentSelectPage[];
}
interface IPageComponentSelectPage {
    page: number;
}
@ICmsComponent<CmsBlogComponentMoreStoriesComponent>({
    id: 'blog-more-stories',
    name: 'Blog / More Stories',
    tags: ['blog'],
    fields: [
        <NICmsContentField.IField>{
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            default: 'More stories'
        },
        <NICmsContentField.IChoiceField>{
            key: 'title_font_style',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title Font Style',
            options: TextStyleOptions,
            default: 'h1'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Blog pages',
            itemName: 'item',
            defaultSize: 4,
            fields: [
                <NICmsContentField.IRelationField>{
                    key: 'page',
                    type: NICmsContentField.EFieldType.relation,
                    title: 'Select Page',
                    required: true,
                    options: {
                        title: 'Page',
                        type: 'page',
                        multiple: false,
                        filter: (model: ICmsPage, data: IPageDataV4) => model.rawData?.pageType === NBlogPostPageType.typeId
                    }
                }
            ],
            default: [{ page: -101 }, { page: -101 }, { page: -101 }, { page: -101 }]
        }
    ]
})
@Component({
    selector: 'cms-blog-component-more-stories',
    templateUrl: 'cms-blog-component-more-stories.html',
    standalone: true,
    imports: [ICmsClientModule, NgClass, CmsBlogComponentMoreStoriesItemComponent, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentMoreStoriesComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentBlogMoreStoriesData;
    pages?: IPageComponentSelectPage[];
    end = 0;
    isBtnVisible?: boolean;
    override ngOnInit() {
        super.ngOnInit();
        this.loadMore();
    }
    getPages(): IPageComponentSelectPage[] {
        if (this.client.isS || this.client.isM) {
            this.end += 2;
        } else {
            this.end += 4;
        }
        const items = this.component.items;
        if(items) {
            if (this.end > items.length) {
                return items;
            } else {
                return items.slice(0, this.end);
            }
        }
        return [];
    }
    checkBtnStatus(): boolean {
        if (!this.pages || !this.component.items){
             return false;
        }
        return this.pages.length < this.component.items.length;
    }
    loadMore() {
        this.pages = this.getPages();
        this.isBtnVisible = this.checkBtnStatus();
        this.detectChanges();
    }
}
